import { motion } from "framer-motion";
import { CASE_STUDIES } from "../data/site";

const Block = ({ label, text }) => (
  <div>
    <p className="font-display text-[11px] uppercase tracking-[0.25em] font-bold text-[#0047FF] mb-2">{label}</p>
    <p className="text-white/70 leading-relaxed text-sm md:text-base">{text}</p>
  </div>
);

export const CaseStudies = () => (
  <section data-testid="case-studies-section" className="bg-[#0A0A0A] text-white py-24 md:py-32 relative noise">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <p className="font-display text-xs uppercase tracking-[0.3em] font-semibold text-[#FFB6C1] mb-4">Case Studies</p>
      <h2 className="font-display font-black tracking-tighter text-4xl md:text-6xl leading-none mb-16 md:mb-24">
        Challenge → Made → <span className="text-[#0047FF]">Result</span>
      </h2>

      <div className="space-y-20 md:space-y-28">
        {CASE_STUDIES.map((c, i) => (
          <motion.article
            key={c.num}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`case-study-${c.num}`}
            className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
          >
            <div className="md:col-span-6 [direction:ltr]">
              <div className="overflow-hidden rounded-lg aspect-[4/3]">
                <img src={c.image} alt={c.title} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
            </div>
            <div className="md:col-span-6 [direction:ltr]">
              <div className="flex items-baseline gap-4 mb-6">
                <span className="font-display font-black text-6xl md:text-7xl text-[#FFB6C1]">{c.num}</span>
                <div>
                  <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight">{c.title}</h3>
                  <p className="text-xs uppercase tracking-widest text-[#FFB6C1] font-semibold mt-1">{c.tag}</p>
                </div>
              </div>
              <div className="space-y-6 border-l-2 border-[#0047FF] pl-6">
                <Block label="Challenge" text={c.challenge} />
                <Block label="What I made" text={c.made} />
                <Block label="Result" text={c.result} />
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
